<template>
  <div :class="_.waterfall">
    <dmbc-base-masonry :col-count="2" :row-gap="4">
      <div
        v-for="(item, index) in data"
        :key="index"
        v-track="{
          name: '商品瀑布流-商品',
          id: `${componentId}-goods`,
          resource: item,
          index: index,
        }"
        :class="_.item"
        @click="$dmbcResourceClick(item)"
      >
        <div :class="_.frame"></div>
        <img :src="item.icon" :class="_.cover" />
        <div :class="_.content">
          <div :class="_.name">
            {{ item.title }}
          </div>
          <div :class="_.extra">
            <div :class="_.price"><span>￥</span>{{ item.discountAmt }}</div>
            <div v-if="theme.showSellCount === true" :class="_.sales">
              销量 {{ item.sales }}
            </div>
          </div>
        </div>
      </div>
    </dmbc-base-masonry>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .waterfall {
    font-size: 0;

    .item {
      position: relative;
      width: 178px;
      height: 256px;

      .frame {
        position: absolute;
        inset: 0;
        background-image: url('./images/框.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 2;
      }

      .cover {
        position: absolute;
        top: 6px;
        left: 6px;
        width: 166px;
        height: 166px;
        border-radius: 8px;
        object-fit: cover;
        z-index: 1;
      }

      .content {
        position: absolute;
        z-index: 3;
        top: 175px;
        left: 11px;
        right: 11px;

        .name {
          height: 40px;
          font-size: 14px;
          font-weight: bold;
          color: #333333;
          line-height: 20px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .extra {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .price {
            font-size: 24px;
            font-weight: bold;
            color: #ff3b30;
            line-height: 33px;

            span {
              font-size: 12px;
            }
          }

          .sales {
            font-size: 12px;
            color: #b4b4b4;
            line-height: 17px;
          }
        }
      }
    }
  }
</style>
